export const FETCH_SELLER = 'fetch/seller'
export const SET_ERROR_SELLER = 'set/error/seller'
